// From type to numbers
// returns an int[2] 
/* NUMBERS TO FUNCTION KEY
  111: Ti
  110: Te
  101: Fi
  100: Fe
  911: Ni
  910: Ne
  901: Si
  900: Se
*/
import {getFunctionsFromType} from './getFunctionsFromType'
function getNumbersFromType(_MBTI) {

    var stack = [0, 0];
    var f = getFunctionsFromType(_MBTI);
    var firstFunction = f[0];
    var secondFunction = f[1];
    var intfirstFunction, intsecondFunction;

    var first1 = 9;
    var second1 = 0;
    var third1 = 0;
    if (firstFunction.substring(0, 1) === "T" || firstFunction.substring(0, 1) === "F") first1 = 1;
    if (firstFunction.substring(0, 1) === "T" || firstFunction.substring(0, 1) === "N") second1 = 1;
    if (firstFunction.substring(1, 2) === "i") third1 = 1;
    intfirstFunction = first1 * 100 + second1 * 10 + third1;

    var first2 = 9;
    var second2 = 0;
    var third2 = 0;
    if (secondFunction.substring(0, 1) === "T" || secondFunction.substring(0, 1) === "F") first2 = 1;
    if (secondFunction.substring(0, 1) === "T" || secondFunction.substring(0, 1) === "N") second2 = 1;
    if (secondFunction.substring(1, 2) === "i") third2 = 1;
    intsecondFunction = first2 * 100 + second2 * 10 + third2;

    stack[0] = intfirstFunction;
    stack[1] = intsecondFunction;
    return stack;

}

export { getNumbersFromType }